
import { useStore } from '@/store'
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'AgendaNavbar',
  props: {
    modelValue: {
      type: Number,
      required: true
    }
  },
  setup (props, context) {
    const { agendaDays: days } = useStore()
    const selectedDay = computed(() => days.value[props.modelValue])

    const onTabClick = (dayIndex: number) => {
      context.emit('update:modelValue', dayIndex)
    }

    return {
      days,
      selectedDay,
      onTabClick
    }
  }
})
